import { Routes } from '@angular/router';
import { redirectFn } from './core/functions/redirect.function';
import { roleGuard } from './core/guards/role.guard';
import { RoleGroup } from './shared/roles/models/role-group';
import { ERole } from './shared/roles/models/role.enum';

export const routes: Routes = [
  {
    path: '',
    redirectTo: redirectFn,
    pathMatch: 'full',
  },
  {
    path: 'config',
    title: 'Config | Beacon',
    loadChildren: () => import('./config/config.routes').then((m) => m.routes),
    canActivate: [roleGuard],
    data: { requireAny: [ERole.MAINTENANCE] },
  },
  {
    path: 'incidents',
    loadChildren: () => import('./ir-profile/ir-profile.routes').then((m) => m.routes),
    canActivate: [roleGuard],
    data: { requireAny: [ERole.DETAIL] },
  },
  {
    path: 'new',
    loadChildren: () => import('./new-ir/new-ir.routes').then((m) => m.routes),
    canActivate: [],
  },
  {
    path: 'search',
    title: 'Search | Beacon',
    loadChildren: () => import('./search/search.routes').then((m) => m.routes),
    canActivate: [roleGuard],
    data: { requireAny: [ERole.SEARCH] },
  },
  {
    path: 'student/cases',
    loadChildren: () => import('./student/student.routes').then((m) => m.routes),
    canActivate: [],
  },
  {
    path: 'incident-queue/active',
    loadChildren: () => import('./queues/queues.routes').then((m) => m.routes),
    canActivate: [roleGuard],
    data: { requireAny: RoleGroup.NON_INCIDENT_QUEUES },
  },
  {
    path: 'case-converter/:case_id/incident/:incident_id/:incident_type',
    title: 'Case Converter | Beacon',
    loadChildren: () =>
      import('./ir-profile/components/case-converter/case-converter.routes').then((m) => m.routes),
    canActivate: [],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
